module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.f99a231e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fontawesome-webfont.svg
// module id = ./src/fonts/fontawesome-webfont.svg
// module chunks = 0